import { useTranslation } from "react-i18next";
import { AppLanguage, SUPPORTED_LANGUAGES } from "../i18n-config";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { i18n, t } = useTranslation();

  const setLanguage = (lang: AppLanguage) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div
      className={`inline-flex items-center rounded-full bg-canvas-200/50 p-0.5 text-xs font-medium ${className}`}
      role="group"
      aria-label={t("common.language")}
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => setLanguage(lang)}
          className={`rounded-full px-3 py-1.5 transition-all duration-200 ${
            i18n.language === lang
              ? "bg-white text-canvas-950 shadow-sm"
              : "text-canvas-600 hover:text-canvas-900"
          }`}
          aria-pressed={i18n.language === lang}
        >
          {t(`common.languages.${lang}`)}
        </button>
      ))}
    </div>
  );
}
